// components/Login.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Determine the base URL based on the environment
  const API_BASE_URL =
    process.env.NODE_ENV === 'production'
      ? 'https://superserver.tarn.co'
      : 'http://localhost:5002';

  useEffect(() => {
    // Check for token in URL (for Google OAuth redirect)
    const token = new URLSearchParams(window.location.search).get('token');
    if (token) {
      localStorage.setItem('jwtToken', token); // Save the token in localStorage
      navigate('/'); // Redirect to home or another protected route
    }
    setLoading(false);
  }, [navigate, API_BASE_URL]);

  const handleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/google`;
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#f9f9f9]">
      <h1 className="text-xl font-semibold mb-6">Access Restricted</h1>
      <p className="mb-4 text-gray-700">
        You must log in with Google to access this internal admin panel.
      </p>
      <button onClick={handleLogin} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Login with Google
      </button>
    </div>
  );
};

export default Login;